import { render } from "./CorpIdentity.vue?vue&type=template&id=234599f7&scoped=true"
import script from "./CorpIdentity.vue?vue&type=script&lang=js"
export * from "./CorpIdentity.vue?vue&type=script&lang=js"

import "./CorpIdentity.vue?vue&type=style&index=0&id=234599f7&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234599f7"]])

export default __exports__